<template>
  <div class="resumo">
    <div class="resumo__cabecalho">
      <div class="resumo__cabecalho-principal">
        <span class="resumo__icone-grande"><fa-icon icon="wallet" /></span>
        <div class="resumo__cabecalho-texto">
          <div class="resumo__nome" :class="{ 'resumo__vazio': !item.nome }">{{ item.nome || "Regra sem nome" }}</div>
          <div class="resumo__meta">
            <span :class="['resumo__status', item.ativo ? 'resumo__status--ativa' : 'resumo__status--inativa']">
              <fa-icon :icon="item.ativo ? 'check-circle' : 'pause-circle'" class="mr-1" />{{ item.ativo ? "Ativa" : "Inativa" }}
            </span>
            <span class="resumo__meta-item"><fa-icon icon="sort-amount-down" class="mr-1" />Prioridade {{ item.prioridade || 0 }}</span>
            <span class="resumo__meta-item"><fa-icon icon="calendar-alt" class="mr-1" />{{ vigencia }}</span>
          </div>
        </div>
      </div>
      <div class="resumo__canais">
        <span v-for="canal in canaisSelecionados" :key="canal.chave" class="resumo__canal">
          <img v-if="canal.imagem" :src="canal.imagem" alt="" class="resumo__canal-logo" />
          {{ canal.label }}
        </span>
        <span v-if="!canaisSelecionados.length" class="resumo__vazio">Nenhum canal selecionado</span>
      </div>
    </div>

    <div class="resumo__bloco">
      <div class="resumo__bloco-titulo"><fa-icon icon="percent" class="mr-2" />Quanto o cliente ganha</div>
      <div v-if="faixasOrdenadas.length" class="resumo__faixas">
        <div v-for="(faixa, indice) in faixasOrdenadas" :key="indice" class="resumo__faixa" :style="{ '--intensidade': intensidade(faixa) }">
          <span class="resumo__faixa-percentual">{{ formatPercentual(faixa.percentual) }}</span>
          <span class="resumo__faixa-intervalo">{{ intervaloFaixa(faixa) }}</span>
        </div>
      </div>
      <div v-else class="resumo__vazio">Nenhuma faixa cadastrada</div>
      <div class="resumo__notas">
        <span><fa-icon icon="calculator" class="mr-1" />Base: {{ baseValor.toLowerCase() }}</span>
        <span v-if="tetoUltimaFaixa"><fa-icon icon="layer-group" class="mr-1" />Acima de {{ formatMoney(tetoUltimaFaixa) }}: {{ comportamentoTeto.toLowerCase() }}</span>
      </div>
    </div>

    <div class="resumo__bloco">
      <div class="resumo__bloco-titulo"><fa-icon icon="filter" class="mr-2" />Quem participa</div>
      <div class="resumo__cartoes">
        <div v-for="grupo in grupos" :key="grupo.opcao" class="resumo__cartao">
          <div class="resumo__cartao-titulo"><fa-icon :icon="grupo.icone" class="mr-2" />{{ grupo.titulo }}</div>
          <div v-if="!linhasDo(grupo).length" class="resumo__vazio">{{ grupo.vazio }}</div>
          <template v-else>
            <div class="resumo__exigencia">{{ grupo.exigencia }}</div>
            <ul class="resumo__linhas">
              <li v-for="(linha, indice) in linhasDo(grupo)" :key="linha.chave">
                <span v-if="indice" class="resumo__conector">{{ grupo.conector }}</span>
                <strong>{{ linha.rotulo }}:</strong> {{ linha.valores }}
              </li>
            </ul>
          </template>
        </div>
      </div>
    </div>

    <div class="resumo__bloco">
      <div class="resumo__bloco-titulo"><fa-icon icon="sliders-h" class="mr-2" />Combinações</div>
      <div class="resumo__combinacoes">
        <span
          v-for="combinacao in combinacoes"
          :key="combinacao.campo"
          :class="['resumo__combinacao', { 'resumo__combinacao--nao': !item[combinacao.campo] }]"
        >
          <fa-icon :icon="item[combinacao.campo] ? 'check' : 'times'" class="mr-1" />{{ combinacao.resumo }}
        </span>
      </div>
      <div v-if="item.permiteComUsoCashback" class="resumo__destaque">
        <fa-icon icon="hand-holding-usd" class="mr-2" />
        <span><strong>{{ ganhoComUso.titulo }}</strong> quando o pedido usa saldo: {{ ganhoComUso.resumo }}.</span>
      </div>
    </div>

    <div class="resumo__indicadores">
      <div class="resumo__indicador">
        <span class="resumo__indicador-icone"><fa-icon icon="clock" /></span>
        <div>
          <div class="resumo__indicador-rotulo">Validade do saldo</div>
          <div class="resumo__indicador-valor">{{ Number(item.validadeDias) > 0 ? `${item.validadeDias} dias após o faturamento` : "Sem prazo de validade" }}</div>
        </div>
      </div>
      <div class="resumo__indicador">
        <span class="resumo__indicador-icone resumo__indicador-icone--alerta"><fa-icon icon="exclamation-triangle" /></span>
        <div>
          <div class="resumo__indicador-rotulo">Inadimplência</div>
          <div class="resumo__indicador-valor">{{ titulosVencidos }}</div>
          <div class="resumo__indicador-detalhe">{{ mediaAtraso }}</div>
        </div>
      </div>
      <div class="resumo__indicador">
        <span class="resumo__indicador-icone"><fa-icon icon="lock" /></span>
        <div>
          <div class="resumo__indicador-rotulo">Limites</div>
          <div class="resumo__indicador-valor" :class="{ 'resumo__vazio': !limites }">{{ limites || "Sem limites" }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatData, formatMoney, formatPercentual, ordenarFaixas } from "../../helpers";
import { COMBINACOES, ganhoComUso as descreverGanhoComUso } from "../helpers";
import { imagemCanal } from "../../canais";

const formatarData = (data) => formatData(data, null);

export default {
  name: "StepResumo",

  props: {
    item: { type: Object, required: true },
    opcoes: { type: Object, required: true },
    valores: { type: Object, default: () => ({}) },
    dimensoes: { type: Array, default: () => [] },
  },

  data() {
    return {
      combinacoes: COMBINACOES,
      grupos: [
        {
          opcao: "restricoesProduto",
          titulo: "Produtos",
          icone: "cubes",
          vazio: "Sem filtro de produtos: todos os itens do pedido entram na base do cashback.",
          exigencia: "Itens que se encaixam em qualquer uma:",
          conector: "ou",
        },
        {
          opcao: "restricoesCliente",
          titulo: "Clientes",
          icone: "users",
          vazio: "Sem restrição de clientes: todos participam.",
          exigencia: "Clientes que atendem a todas:",
          conector: "e",
        },
        {
          opcao: "restricoesCondicao",
          titulo: "Condições comerciais",
          icone: "file-invoice-dollar",
          vazio: "Sem restrição: vale para qualquer operação, cobrança, plano de pagamento e vendedor.",
          exigencia: "Pedidos que atendem a todas:",
          conector: "e",
        },
      ],
    };
  },

  computed: {
    ganhoComUso() {
      return descreverGanhoComUso(this.item.baseComUso);
    },

    vigencia() {
      const inicio = formatarData(this.item.dataInicio);
      const fim = formatarData(this.item.dataFim);

      if (inicio && fim) return `${inicio} a ${fim}`;
      if (inicio) return `A partir de ${inicio}`;
      if (fim) return `Até ${fim}`;

      return "Sem prazo";
    },

    tetoUltimaFaixa() {
      const ultima = this.faixasOrdenadas[this.faixasOrdenadas.length - 1];

      return ultima && Number(ultima.valorMaximo) > 0 ? Number(ultima.valorMaximo) : null;
    },

    comportamentoTeto() {
      const opcao = (this.opcoes.comportamentosTeto || []).find((item) => item.chave === (this.item.comportamentoTeto || "SEM_CASHBACK"));

      return opcao ? opcao.label : "Não gera cashback";
    },

    baseValor() {
      const base = (this.opcoes.basesValor || []).find((opcao) => opcao.chave === (this.item.baseValor || "COM_IMPOSTO"));
      return base ? base.label : "Valor dos itens com impostos";
    },

    faixasOrdenadas() {
      return ordenarFaixas(this.item.faixas);
    },

    canaisSelecionados() {
      return (this.opcoes.canais || [])
        .filter((canal) => this.item.canais.includes(canal.chave))
        .map((canal) => ({ chave: canal.chave, label: canal.label, imagem: imagemCanal(canal.chave) }));
    },

    maiorPercentual() {
      return Math.max(0, ...this.faixasOrdenadas.map((faixa) => Number(faixa.percentual) || 0));
    },

    titulosVencidos() {
      if (!this.item.exigeSemTituloVencido) return "Não bloqueia";

      const tolerancia = Number(this.item.toleranciaDiasTituloVencido || 0);

      return tolerancia ? `Bloqueia após ${tolerancia} dias de atraso` : "Bloqueia qualquer atraso";
    },

    mediaAtraso() {
      const maxima = this.item.mediaAtrasoMaximaDias;

      if (maxima === null || maxima === undefined || maxima === "") return "Não verifica a média de atraso";

      const meses = Number(this.item.mediaAtrasoMeses) > 0 ? Number(this.item.mediaAtrasoMeses) : 12;

      return `Média de atraso até ${maxima} ${Number(maxima) === 1 ? "dia" : "dias"} nos últimos ${meses} ${meses === 1 ? "mês" : "meses"}`;
    },

    limites() {
      const periodo = (this.opcoes.periodos || []).find((opcao) => opcao.chave === this.item.limitePeriodo);
      const sufixo = periodo ? ` por ${periodo.label.toLowerCase()}` : "";

      return [
        Number(this.item.limiteValorPedido) > 0 ? `${formatMoney(this.item.limiteValorPedido)} por pedido` : null,
        Number(this.item.limiteValorCliente) > 0 ? `${formatMoney(this.item.limiteValorCliente)} por cliente${sufixo}` : null,
        Number(this.item.limiteValorTotal) > 0 ? `${formatMoney(this.item.limiteValorTotal)} no total${sufixo}` : null,
      ]
        .filter(Boolean)
        .join(" · ");
    },
  },

  methods: {
    formatMoney,
    formatPercentual,

    intervaloFaixa(faixa) {
      const minimo = Number(faixa.valorMinimo) || 0;
      const maximo = Number(faixa.valorMaximo) > 0 ? Number(faixa.valorMaximo) : null;

      if (maximo === null) return `A partir de ${formatMoney(minimo)}`;

      return `${formatMoney(minimo)} a ${formatMoney(maximo)}`;
    },

    intensidade(faixa) {
      return this.maiorPercentual > 0 ? 0.6 + (0.4 * (Number(faixa.percentual) || 0)) / this.maiorPercentual : 0.6;
    },

    linhasDo(grupo) {
      const tipos = this.opcoes[grupo.opcao] || [];
      const linhas = [];

      this.item.restricoes
        .filter((restricao) => tipos.some((tipo) => tipo.chave === restricao.tipo))
        .forEach((restricao) => {
          const chave = `${restricao.tipo}|${restricao.dimensaoColuna || ""}`;
          let linha = linhas.find((item) => item.chave === chave);

          if (!linha) {
            linha = { chave, rotulo: this.rotuloTipo(restricao, tipos), lista: [] };
            linhas.push(linha);
          }

          linha.lista.push(this.descricaoValor(restricao));
        });

      return linhas.map((linha) => ({ ...linha, valores: this.juntarComOu(linha.lista) }));
    },

    juntarComOu(valores) {
      if (valores.length < 2) return valores.join("");

      return `${valores.slice(0, -1).join(", ")} ou ${valores[valores.length - 1]}`;
    },

    rotuloTipo(restricao, tipos) {
      if (restricao.tipo === "DIMENSAO") {
        const dimensao = this.dimensoes.find((item) => String(item.coluna) === String(restricao.dimensaoColuna));

        if (dimensao) return dimensao.label;
      }

      const tipo = tipos.find((item) => item.chave === restricao.tipo);

      return tipo ? tipo.label : restricao.tipo;
    },

    descricaoValor(restricao) {
      const lista = restricao.tipo === "DIMENSAO"
        ? (this.dimensoes.find((item) => String(item.coluna) === String(restricao.dimensaoColuna)) || { opcoes: [] }).opcoes
        : this.valores[restricao.tipo] || [];
      const opcao = lista.find((item) => String(item.id) === String(restricao.chave));

      if (opcao) return opcao.descricao;

      return restricao.rotulo || restricao.chave;
    },
  },
};
</script>

<style scoped>
.resumo {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.resumo__cabecalho {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--cashback-cor-primaria-suave), #ffffff);
  border: 1px solid #eaecf0;
}

.resumo__cabecalho-principal {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.resumo__icone-grande {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background-color: var(--cashback-cor-primaria);
  color: #ffffff;
  font-size: 18px;
  flex-shrink: 0;
}

.resumo__cabecalho-texto {
  min-width: 0;
}

.resumo__nome {
  font-size: 17px;
  font-weight: 700;
  color: #101828;
}

.resumo__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 4px;
  font-size: 12px;
  color: #667085;
}

.resumo__status {
  font-weight: 600;
}

.resumo__status--ativa {
  color: #067647;
}

.resumo__status--inativa {
  color: #98a2b3;
}

.resumo__canais {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.resumo__canal {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px 3px 4px;
  border-radius: 999px;
  background-color: #ffffff;
  border: 1px solid var(--cashback-cor-primaria);
  color: var(--cashback-cor-primaria);
  font-size: 12px;
  font-weight: 600;
}

.resumo__canal-logo {
  width: 18px;
  height: 18px;
  padding: 1px;
  border-radius: 50%;
  background-color: #ffffff;
  object-fit: contain;
}

.resumo__bloco {
  padding: 14px 16px;
  border: 1px solid #eaecf0;
  border-radius: 10px;
}

.resumo__bloco-titulo {
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #475467;
}

.resumo__faixas {
  display: flex;
  gap: 8px;
}

.resumo__faixa {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 10px 8px;
  border-radius: 8px;
  position: relative;
  z-index: 0;
  color: #ffffff;
  text-align: center;
}

.resumo__faixa::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  border-radius: 8px;
  background-color: var(--cashback-cor-primaria);
  opacity: var(--intensidade);
}

.resumo__faixa-percentual {
  font-size: 20px;
  font-weight: 800;
  line-height: 1.1;
}

.resumo__faixa-intervalo {
  font-size: 11.5px;
}

.resumo__notas {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 10px;
  font-size: 12.5px;
  color: #475467;
}

.resumo__cartoes {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.resumo__cartao {
  padding: 10px 12px;
  border-radius: 8px;
  background-color: #f9fafb;
  min-width: 0;
}

.resumo__cartao-titulo {
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 700;
  color: #344054;
}

.resumo__exigencia {
  margin-bottom: 4px;
  font-size: 11.5px;
  color: #667085;
}

.resumo__linhas {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 13px;
  color: #344054;
  line-height: 1.6;
  word-break: break-word;
}

.resumo__conector {
  display: inline-block;
  margin-right: 4px;
  padding: 0 5px;
  border-radius: 4px;
  background-color: var(--cashback-cor-primaria-suave);
  color: var(--cashback-cor-primaria);
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
}

.resumo__combinacoes {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.resumo__combinacao {
  padding: 3px 10px;
  border-radius: 999px;
  background-color: #ecfdf3;
  color: #067647;
  font-size: 12px;
  font-weight: 600;
}

.resumo__combinacao--nao {
  background-color: #f2f4f7;
  color: #98a2b3;
  text-decoration: line-through;
}

.resumo__destaque {
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
  padding: 8px 12px;
  border-radius: 8px;
  background-color: var(--cashback-cor-primaria-suave, #eceaf3);
  color: var(--cashback-cor-primaria, #3a3e81);
  font-size: 12.5px;
}

.resumo__indicadores {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.resumo__indicador {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  border: 1px solid #eaecf0;
  border-radius: 10px;
}

.resumo__indicador-icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: var(--cashback-cor-primaria-suave);
  color: var(--cashback-cor-primaria);
  flex-shrink: 0;
}

.resumo__indicador-icone--alerta {
  background-color: #fffaeb;
  color: #b54708;
}

.resumo__indicador-rotulo {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #98a2b3;
}

.resumo__indicador-valor {
  font-size: 13px;
  font-weight: 600;
  color: #101828;
}

.resumo__indicador-detalhe {
  font-size: 12px;
  color: #667085;
}

.resumo__vazio {
  color: #98a2b3;
  font-style: italic;
  font-size: 12.5px;
}

@media (max-width: 768px) {
  .resumo__faixas {
    flex-direction: column;
  }

  .resumo__cartoes,
  .resumo__indicadores {
    grid-template-columns: 1fr;
  }
}
</style>
